import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { processDomainDataLists, getDateStringFromWeek } from './DealsDataHelper';
import styled, { createGlobalStyle } from "styled-components";

const Flexouter = styled("div")`
display: flex;
flex-direction: row;
justify-content: space-between;
border: 0px solid blue;
width: 100%;
`;

const Flexinner = styled("div")`
padding: 2px;
border:0px solid black;
margin:0px;
`;


//const DealDisplay = ({ obj }) => {
const TestDataDisplay = (props) => {
  //console.log("propid", obj['property_id']);
  let obj = props['data'];

  // let sdatestr = new Date(obj.accommodations['startmillis']).toDateString();
  // let edatestr = new Date(obj.accommodations['endmillis']).toDateString();
  //let imgsrc = 'http://ldphotos.s3.amazonaws.com/' + obj['id'] + '.jpg';
  let imgsrc = 'no image';
  if (obj.photos.length > 0) {
    imgsrc = 'image ' + obj.photos[0]['url'];
  }
  let bedrooms = 'no beds';
  if (obj.accommodations.length > 0) {
    bedrooms = 'beds ' + obj.accommodations[0]['bedrooms'];
  }


  // let imgsrc = obj.photos[0]['url']; //['photo_path'] + '.jpg';
  let adrstr = obj['state'];


  //  console.log(adrstr.length, ' - ', adrstr)



  let divid = 'ddid-' + obj['id'];



  return (
    <div id={divid} className="dealdisplay">



      <div className="flex_row">
        <div>
          <b>{obj.company_name}</b>
        </div>

      </div>
      <div className="flex_row" style={{ borderTop: "1px solid #aaa" }}>
        <div >{obj.name}</div>
        <div >{obj.state}</div>
      </div>





      <div className="flex_row">

        <div className="flex_item">
          {bedrooms}
        </div>
        <div className="flex_item" >
          {imgsrc}
        </div>
      </div>



    </div>


  )


  // return (
  //   <div style={{ borderBottom: "2px solid blue", padding: "5px" }}>
  //     <h4>{obj.booking_url}</h4>
  //     <h4 style={{ borderBottom: "1px solid black" }}>{obj.title}</h4>
  //     <span>price={obj.price}</span>&nbsp;<span>ppn={obj.ppn}</span>
  //     <div>{obj.property[0]['name']}</div>
  //     <div>
  //       <span>{obj.property[0]['city']}</span>,&nbsp;<span>{obj.property[0]['state']}</span>
  //     </div>
  //     <div>
  //       <span>lat {obj.property[0]['latitude']}</span>&nbsp;<span>lon {obj.property[0]['longitude']}</span>
  //     </div>
  //     {/* <div>{obj.photos[0]['url']}</div> */}
  //   </div>
  // )
  /*
   return (
    <div>
      <h4>{obj.price}</h4>
      <span>{obj.booking_url}</span>
    </div>
  )
  */

}



export default TestDataDisplay;



// WEBPACK FOOTER //
// ./src/components/deals/TestDataDisplay.js